import React, { useState } from 'react'
import stylesheet from "./login.module.css"
import ButtonInit from "../../component/button/index"
import Input from "../../component/input/index"

const Login = () => {
    const [login, setlogin] = useState(true)
    const [password, setpassword] = useState(false)
    const [Cpasswrd, setCpasswrd] = useState(false)

    function loginfalse() {
        setlogin(false)
    }
    return (
        <>
        <div className={`col-12 ${stylesheet.main_login} p-0`}>
        {login!==false?
            <div>
                <h5>Login to your account</h5>
                <div className='w-100 d-flex align-items-center justify-content-center flex-column pt-4'>
                    <Input placeholder={"your email address *"}/>
                    <Input placeholder={"Password *"}/>
                </div>
                <p>Forgot Password?</p>
                <p className={stylesheet.require}>*Required Field</p>
                <div className="d-flex align-items-center justify-content-between">
                <div className='px-1 w-100'>
                    <ButtonInit width={"100"} value={"Login"}/>
                    </div>
                <div className='px-1 w-100'>

                    <ButtonInit width={"100"} func={loginfalse} onclick value={"Register"}/>
                    </div>

                </div>
            </div>
            :
            <div>
                <h5>Register to your account</h5>
                <div className='w-100 d-flex align-items-center justify-content-center flex-column pt-4'>
                    <Input placeholder={"Name *"}/>
                    <Input placeholder={"Surname *"}/>
                    <Input placeholder={"Your Email address *"}/>
                    <p className='mb-0 mt-2'><b>Password</b> 8 characters minimum lenght</p>
                    <div className={stylesheet.password_input_div}>
                    <Input type={password == false?"password":"text"} placeholder={"New Password (min 8 chars) *"}/>
                    <button onClick={()=>{password == false?setpassword(true):setpassword(false)}}>
                        {password == false?
                        <img src="https://img.icons8.com/material-outlined/24/000000/invisible.png"/>
                        :   
                        <img src="https://img.icons8.com/android/24/000000/invisible.png"/>
                        }
                    </button>
                    </div>
                    <div className={stylesheet.password_input_div}>
                    <Input type={Cpasswrd == false?"password":"text"} placeholder={"Confirm Password"}/>
                    <button onClick={()=>{Cpasswrd == false?setCpasswrd(true):setCpasswrd(false)}}>
                        {Cpasswrd == false?
                        <img src="https://img.icons8.com/material-outlined/24/000000/invisible.png"/>
                        :   
                        <img src="https://img.icons8.com/android/24/000000/invisible.png"/>
                        }
                    </button>
                    </div>
                </div>
                <div className='d-flex align-items-start py-2'> 
                    <input type="checkbox" className='mt-1'/> 
                    <div><p className='mb-0 mt-0 ml-2'>I have read and agree to the</p><p className={`mb-0 mt-0 ml-2 ${stylesheet.require}`}>Privacy policy *</p></div>
                </div>
                <div className="d-flex align-items-center justify-content-between">
                    <ButtonInit width={"100"} value={"Register"}/>
                </div>
            </div>
            }
        </div>
        </>
    )
}



export default React.memo(Login)
